import { Component, OnInit,OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AlertaDto } from '../../../dto/alerta/alerta.dto';
import { AlertaService } from '../../../services/alerta.service';
import { AlertaFiltroDto } from '../../../dto/alerta/alerta.filtro.dto';
import { ExpedienteDto } from '../../../dto/expediente/expediente.dto';
import { NavigationEnd, Router } from '@angular/router';
import { Constants } from '../../../constants/constants';
import { UserDataDto } from '../../../dto/auth/user-data.dto';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { UtilService } from '../../../services/util.service';
import { PowerbiService } from '../../../services/powerbi.service';
import { AlertaModalService } from '../../../services/util/alerta-modal.service';
import { MiddlewareService } from '../../../services/middleware.service';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-visualizar-alertas',
  templateUrl: './visualizar-alertas.component.html',
  styleUrl: './visualizar-alertas.component.scss',
})
export class VisualizarAlertasComponent implements OnInit, OnDestroy {
  filtrosAlertas: FormGroup;
  alertas: AlertaDto[] = [];
  pagina = 1;
  totalPaginas = 0;
  countAlertas = 0;
  infoPantalla: InfoPantallaDTO = {};
  private userData: UserDataDto = {};
  private destroy$ = new Subject<void>();
  // Tooltip
  tooltipVisible: string | null = null;
  constructor(
    private formBuilder: FormBuilder,
    private alertaService: AlertaService,
    private router: Router,
    private utilService: UtilService,
    private pbiService: PowerbiService,
    private alertaModalService: AlertaModalService,
    private middlewareService: MiddlewareService
  ) {
    this.filtrosAlertas = this.formBuilder.group({
      noLeido: [true],
      archivado: [false],
      prioritario: [false],
    });
    this.utilService.watchInfoPantalla().pipe(takeUntil(this.destroy$)).subscribe((info: InfoPantallaDTO) => {
      if (info) {
        this.infoPantalla = info;
      }
    });
    this.middlewareService.action$.pipe(takeUntil(this.destroy$)).subscribe(() => this.desplegarAlertas());
  }

  ngOnInit() {
    this.userData = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
  this.router.events
    .pipe(takeUntil(this.destroy$))
    .subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.pagina = 1;
        this.userData = JSON.parse(
          sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
        );
        if (this.userData?.idUsuario) {
          this.filtrarAlertas();
        }
      }
    });
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  desplegarAlertas(){
    this.filtrarAlertas();
  }

  filtrarAlertas() {
    const filtros: AlertaFiltroDto = {
      leido: !this.filtrosAlertas.value.noLeido,
      archivado: this.filtrosAlertas.value.archivado,
      prioritario: this.filtrosAlertas.value.prioritario,
      tipoAlerta: 1,
      usuario: this.userData.idUsuario,
    };
    this.alertaService
      .filtrar({
        tamanoPagina: 10,
        pagina: this.pagina,
        filtros: filtros,
      }).pipe(takeUntil(this.destroy$))
      .subscribe(alertas => {
        this.totalPaginas = alertas.totalPaginas;
        if (this.pagina > 1) {
          this.alertas = this.alertas.concat(alertas.registros);
        } else {
          this.alertas = alertas.registros;
        }
        this.alertas.forEach(alerta => {
          if (alerta.Titulo) {
            const detalle = alerta.Titulo.toLowerCase();
            if (detalle.includes('link')) {
              const partes = detalle.split(':');
              const link = partes[1].trim();
              alerta.Titulo = 'Descarga BD';
              alerta.DB_Id = link;
            }
          }
        });
        this.pagina += 1;
      });
    this.alertaService
      .contarPorFiltro({
        leido: false,
        tipoAlerta: 1,
        usuario: this.userData.idUsuario,
      }).pipe(takeUntil(this.destroy$))
      .subscribe(cantidad => {
        this.countAlertas = cantidad;
      });
  }

  cambiarEstadoLeido(id: number) {
    this.alertaService.cambiarEstadoLeido(id).subscribe(() => {
      this.pagina = 1;
      this.filtrarAlertas();
    });
  }

  cambiarEstadoArchivado(id: number) {
    this.alertaService.cambiarEstadoArchivado(id).subscribe(() => {
      this.pagina = 1;
      this.filtrarAlertas();
    });
  }

  cambiarEstadoPrioritario(id: number) {
    this.alertaService.cambiarEstadoPrioritario(id).subscribe(() => {
      this.pagina = 1;
      this.filtrarAlertas();
    });
  }

  async detalleExpediente(expediente: ExpedienteDto, idUsuario: number) {
    if (this.infoPantalla.change) {
      await this.infoPantalla.change(() => {
        this.navegarDetalleExpediente(expediente, idUsuario);
      });
    } else {
      this.navegarDetalleExpediente(expediente, idUsuario);
    }
  }

  navegarDetalleExpediente(expediente: ExpedienteDto, idUsuarioCreador: number) {
    if(!idUsuarioCreador){
      idUsuarioCreador = 0;
    }
    switch (expediente?.Tipo_Proceso?.Entidad_Id) {
      case 1:
        if (expediente?.Tipo_Proceso?.Id == 20) {
          this.router.navigate(['/expediente/ssm', expediente.Id, (expediente.Usuario_Id_Creador??0)]);
        } else {
          this.router.navigate(['/expediente/supersociedades', expediente.Id, (expediente.Usuario_Id_Creador??0)]);
        }
        break;
      case 2:
        this.router.navigate(['/expediente/sic', expediente.Id, idUsuarioCreador]);
        break;
      case 3:
        this.router.navigate(['/expediente/supersalud', expediente.Id, idUsuarioCreador]);
        break;
      case 4:
        this.router.navigate(['/expediente/superfinanciera', expediente.Id, idUsuarioCreador]);
        break;
      case 5:
        this.router.navigate(['/expediente/dnda', expediente.Id, idUsuarioCreador]);
        break;
      case 6:
        this.router.navigate(['/expediente/dimar', expediente.Id, idUsuarioCreador]);
        break;
      case 7:
        this.router.navigate(['/expediente/ica', expediente.Id, idUsuarioCreador]);
        break;
      case 8:
        this.router.navigate(['/expediente/ssm', expediente.Id, idUsuarioCreador]);
        break;
      default:
        break;
    }
  }
  mostrarTooltip(tooltipId: string): void {
    this.tooltipVisible = tooltipId;
  }

  ocultarTooltip(): void {
    this.tooltipVisible = null;
  }

  descargarDocumento(id_documento: string | undefined) {
    if (id_documento) {
      this.pbiService.downloadFile(id_documento).subscribe(
        (response: Blob) => {
          const blob = new Blob([response], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });
          blob.text().then(text => {
          });
          const url = window.URL.createObjectURL(blob);
          const anchor = document.createElement('a');
          anchor.href = url;
          anchor.download = id_documento + '.xlsx';
          document.body.appendChild(anchor);
          anchor.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(anchor);
          if (response) {
            this.alertaModalService.exito(
              '¡Éxito!',
              'El archivo se ha descargado correctamente.'
            );
          }
        },
        error => {
          this.alertaModalService.error('Error al descargar el archivo');
        }
      );
    }
  }
}
